module.exports = __webpack_public_path__ + "img/2s.cdab847c.png";